import React from 'react'
import printImage from '../../helpers/printImage'
import drawQRBoxLLC from "../../helpers/drawQRBoxLLC"

const NextBoxPrintLLC = (props) => {
    const { box } = props
    const { box_partner_detail } = { ...box }

    const _handleClickPrintQR = (e) => {
        e.preventDefault()

        _requestPrintQR()
    }

    const _requestPrintQR = async () => {
        const imageQr = await drawQRBoxLLC(box)

        console.log(imageQr)
        printImage(imageQr)
    }
    return (
        !!box_partner_detail && <div className='NextBoxPrintLLC ml-2'>
            <button onClick={_handleClickPrintQR} className="btn btn-primary">Print LLC box</button>
        </div>
    )
}

export default NextBoxPrintLLC